import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { LabelingSpec } from '../process-plan'
import { LabelingSpecLabelComponent } from './labeling-spec-label/labeling-spec-label.component'

@Component({
  selector: 'app-labeling-spec-detail',
  templateUrl: './labeling-spec-detail.component.html',
  styleUrls: ['./labeling-spec-detail.component.scss'],
  imports: [LabelingSpecLabelComponent, AsyncPipe, ElderTranslatePipe],
})
export class LabelingSpecDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  public readonly labelingSpec$ = new BehaviorSubject<LabelingSpec>(null)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set labelingSpec(spec: LabelingSpec) {
    this.labelingSpec$.next(spec)
  }
}
